module.exports = __webpack_public_path__ + "static/media/57bba171-2ee6-488c-9f53-44820cb37d13.1385936e.JPG";